import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QualityCheckResultComponent } from "libraries/component/quality-check-result/quality-check-result.component";
import { NotificationModule } from "libraries/component/notification/notification.module";
import { CardModule } from "libraries/ui_card/card.module";

@NgModule({
  declarations: [
      QualityCheckResultComponent
  ],
    imports: [
        CommonModule,
        NotificationModule,
        CardModule,
    ],
  exports: [
      QualityCheckResultComponent
  ]
})
export class QualityCheckResultModule { }
